module.exports = __webpack_public_path__ + "static/media/skin-4.09e1f0c6.svg";